import { BATHROOM_CDN_PATH } from '../../../bathroom-constants';

export const REPAIR_IMAGE = {
  srcLd: `${BATHROOM_CDN_PATH}/repair/professional-1-ld.jpg/professional-1-ld.jpg`,
  srcD: `${BATHROOM_CDN_PATH}/repair/professional-1-d.jpg/professional-1-d.jpg`,
  srcT: `${BATHROOM_CDN_PATH}/repair/professional-1-t.jpg/professional-1-t.jpg`,
  srcM: `${BATHROOM_CDN_PATH}/repair/professional-1-m.jpg/professional-1-m.jpg`,
};

export const REPAIR_YOURSELF_CARD_LIST = [
  {
    title: 'Как измерить ванную комнату',
    media: {
      alt: 'Фото измерения ванной комнаты',
      src: `${BATHROOM_CDN_PATH}/repair/measure.jpg/measure.jpg`,
    },
    link: {
      href: '/advice/santehnika/kak-izmerit-vannuyu-komnatu/',
      title: 'Как измерить ванную комнату',
    }
  },
  {
    title: 'Как уложить плитку на стену',
    media: {
      alt: 'Фото укладки плитки на стену',
      src: `${BATHROOM_CDN_PATH}/repair/tiles-on-wall.jpg/tiles-on-wall.jpg`,
    },
    link: {
      href: '/advice/plitka/kak-ulozhit-plitku-na-stenu/',
      title: 'Как уложить плитку на стену',
    }
  },
  {
    title: 'Как установить тумбу с раковиной',
    media: {
      alt: 'Фото тумбы с раковиной',
      src: `${BATHROOM_CDN_PATH}/repair/install-vanity.jpg/install-vanity.jpg`,
    },
    link: {
      href: '/advice/santehnika/kak-ustanovit-podvesnuyu-tumbu-pod-rakovinu/',
      title: 'Как установить подвесную тумбу под раковину',
    }
  },
  {
    title: 'Как установить ванну',
    media: {
      alt: 'Фото установки ванной',
      src: `${BATHROOM_CDN_PATH}/repair/install-bathtub.jpg/install-bathtub.jpg`,
    },
    link: {
      href: '/advice/santehnika/kak-ustanovit-vannu/',
      title: 'Как установить ванну',
    }
  },
];